import { Component } from '@angular/core';

@Component({
  selector: 'dg-fb-radiobutton-hint',
  templateUrl: './radiobutton-hint.component.html',
  styleUrls: ['./radiobutton-hint.component.scss'],
})
export class RadiobuttonHintComponent {}
